(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  const footerEl = document.querySelector('[footer]')
  footerEl.classList.add('mb-6')
  footerEl.classList.add('md:mb-0')

  } catch(e) { console.error(e); }
})();
})();
